import React from "react";
import Image from "next/image";

const MiniCards = ({ cardsData, cardsStyling = "flex flex-col gap-10" }) => {
  return (
    <div className={`${cardsStyling && cardsStyling}`}>
      {cardsData.map((card, index) => {
        return (
          <div
            key={index}
            className="max-w-[537px] flex flex-col xs:flex-row sm:flex-col lg:flex-row gap-2 sm:gap-4 border px-4 sm:px-6 lg:px-8 py-6 lg:py-4 rounded-xl cardBorders transition-all duration-500 ease-in-out hover:bg-gray-100"
          >
            <div className="w-10 flex items-center justify-center ">
              {card.icon && (
                <div className="text-5xl lg:text-4xl flex justify-center items-center h-full w-full">
                  {card.icon}
                </div>
              )}
              {card.image && (
                <Image
                  src={card.image}
                  width={10}
                  height={10}
                  className={`w-full`}
                  alt="hero"
                />
              )}
            </div>
            <div className="flex-1 flex flex-col sm:gap-2">
              <h3 className="text-xl lg:text-2xl font-bold">{card.title}</h3>
              <p className="text-lg lg:text-xl">{card.description}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default MiniCards;
